import { HttpErrorResponse } from '@angular/common/http';
import { MonoTypeOperatorFunction, throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

const DEFAULT_MAX_RETRIES = 2;
const DEFAULT_BASE_DELAY_MS = 300;

const isTransient = (error: unknown): boolean =>
  error instanceof HttpErrorResponse &&
  (error.status === 0 || error.status >= 500);

export const retryTransient = <T>(
  maxRetries: number = DEFAULT_MAX_RETRIES,
  baseDelayMs: number = DEFAULT_BASE_DELAY_MS
): MonoTypeOperatorFunction<T> =>
  retry<T>({
    count: maxRetries,
    delay: (error, retryCount) =>
      isTransient(error)
        ? timer(baseDelayMs * 2 ** (retryCount - 1))
        : throwError(() => error),
  });
